<template>
  <div class="page-content">
    <TripRequestPageHeading
      @filterData="filterData"
      @downloadTripList="downloadTripList(this.dataInfo.currentPage)"
      pageName="vehicle-request"
      :downloadingTripList="downloadingTripList"
      :filterOptions="[
        { name: 'Modality', value: 'modality' },
        { name: 'Route Name', value: 'routeName' },
        { name: 'Requested Date', value: 'requestedDate' },
        { name: 'Total Distance', value: 'distance' },
        { name: 'Time', value: 'time' },
        { name: 'Company', value: 'companyCode' },
        { name: 'Duty Days', value: 'dutyDays' },
        { name: 'Duty Start Date', value: 'dutyStartDate' },
        { name: 'Service Type', value: 'serviceType' },
        { name: 'Vehicle Type', value: 'vehicleType' },
        { name: 'Requested By', value: 'requestedBy' },
        { name: 'Status', value: 'status' },
        { name: 'Assigned Driver', value: 'assignedDriver' }
      ]"
    ></TripRequestPageHeading>
    <div class="card text-center mt-3">
      <div class="card-body">
        <DefaultLoader v-if="isLoading"></DefaultLoader>
        <template v-else-if="requestList.length > 0">
          <div class="row">
            <div class="col-md-12">
              <select
                v-model="dataInfo.perPage"
                class="form-select form-select-sm"
                style="width: 90px"
              >
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="30">30</option>
                <option value="40">40</option>
                <option value="50">50</option>
              </select>
            </div>
          </div>
          <div class="mt-3">
            <div
              class="table-responsive"
              ref="trTableHolder"
              style="max-height: 65vh"
            >
              <table class="table table-hover">
                <thead style="position: sticky; top: 0; z-index: 10">
                  <tr>
                    <th
                      style="
                        min-width: 100px;
                        max-width: 100px;
                        position: sticky;
                        left: 0;
                      "
                    >
                      TR No.
                    </th>
                    <th style="min-width: 50px">Directionality</th>
                    <th style="min-width: 85px">Requested Date</th>
                    <th style="min-width: 125px">Parent Route</th>
                    <th style="min-width: 165px; position: sticky; left: 100px">
                      Route
                    </th>
                    <th style="min-width: 80px">Path Details</th>
                    <th style="min-width: 50px">Total Distance</th>
                    <th style="min-width: 80px">Time</th>
                    <th style="min-width: 50px">Company</th>
                    <th style="min-width: 50px">Duty Days</th>
                    <th style="min-width: 85px">Week Days</th>
                    <th style="min-width: 85px">Duty Start Date</th>
                    <th style="min-width: 50px">No. Of Vehicle</th>
                    <th style="min-width: 50px">Vehicle Type</th>
                    <th style="min-width: 50px">Service Type</th>
                    <th style="min-width: 50px">Modality</th>
                    <th style="min-width: 85px">Expected Price</th>
                    <th style="min-width: 105px">Requested By</th>
                    <th style="min-width: 100px">Remarks (OPS)</th>
                    <th style="min-width: 50px">Request Status</th>
                    <th style="min-width: 105px">KM Checked By</th>
                    <th style="min-width: 50px">Status</th>
                    <th style="min-width: 50px">Action</th>
                    <th style="min-width: 105px">Assigned Driver</th>
                    <th style="min-width: 100px">Remarks (Partner)</th>
                  </tr>
                </thead>
                <tbody>
                  <template
                    v-for="(request, requestIndex) in requestList"
                    :key="requestIndex"
                  >
                    <template
                      v-for="(
                        requestRoute, index
                      ) in request.trip_request_routes"
                      :key="index"
                    >
                      <tr
                        :class="{
                          'focused-row':
                            selectedRouteInfo?.trip_request_id === request.id &&
                            selectedRouteInfo?.route_id === requestRoute.id
                        }"
                      >
                        <td
                          v-if="!index"
                          :rowspan="request.trip_request_routes.length"
                          style="position: sticky; left: 0; background: #fafafa"
                        >
                          <router-link
                            :to="`/trip-request/vehicle-request/details/${request.id}`"
                            @click="
                              setSelectedRouteInfo(request.id, requestRoute.id)
                            "
                            >{{
                              request.trip_code ? request.trip_code : 'N/A'
                            }}</router-link
                          >
                        </td>
                        <td
                          v-if="!index"
                          :rowspan="request.trip_request_routes.length"
                        >
                          <span
                            v-if="request.trip_request_routes.length > 1"
                            class="partner-badge partner-badge-success rounded-pill"
                            >Both Way</span
                          >
                          <span
                            v-else
                            class="partner-badge partner-badge-primary rounded-pill"
                            >One Way</span
                          >
                        </td>
                        <td
                          v-if="!index"
                          :rowspan="request.trip_request_routes.length"
                        >
                          {{ $format.date(request.requested_date, 'D/MM/YY') }}
                        </td>
                        <td
                          v-if="!index"
                          :rowspan="request.trip_request_routes.length"
                        >
                          <router-link
                            :to="`/trip-request/vehicle-request/details/${request.id}`"
                            @click="
                              setSelectedRouteInfo(request.id, requestRoute.id)
                            "
                            >{{
                              request.parent_route_name
                                ? request.parent_route_name
                                : 'N/A'
                            }}</router-link
                          >
                        </td>
                        <td
                          style="
                            position: sticky;
                            left: 100px;
                            background: #fafafa;
                          "
                        >
                          <router-link
                            :to="`/trip-request/vehicle-request/details/${request.id}/${requestRoute.id}`"
                            @click="
                              setSelectedRouteInfo(request.id, requestRoute.id)
                            "
                            >{{
                              requestRoute.route_name
                                ? requestRoute.route_name
                                : 'N/A'
                            }}</router-link
                          >
                        </td>
                        <td>
                          <!-- <span
                          class="partner-hyperlink"
                          @click="vehicleRequest.redirectToMap(requestRoute)"
                          >See Map</span
                        > -->
                          <span
                            class="partner-hyperlink"
                            @click="selectRequest(request, index)"
                            data-bs-toggle="modal"
                            data-bs-target="#mapModal"
                            >See Map</span
                          >
                        </td>
                        <td>
                          <router-link
                            :to="`/trip-request/vehicle-request/details/${request.id}/${requestRoute.id}`"
                            @click="
                              setSelectedRouteInfo(request.id, requestRoute.id)
                            "
                          >
                            {{
                              requestRoute.distance
                                ? Number(requestRoute.distance).toFixed(2) +
                                  ' km'
                                : 'N/A'
                            }}
                          </router-link>
                        </td>
                        <td>
                          <router-link
                            :to="`/trip-request/vehicle-request/details/${request.id}/${requestRoute.id}`"
                            @click="
                              setSelectedRouteInfo(request.id, requestRoute.id)
                            "
                          >
                            {{
                              requestRoute.pick_up_times?.length > 0
                                ? vehicleRequest.pickUpTimes(
                                    requestRoute.pick_up_times
                                  )
                                : 'N/A'
                            }}
                          </router-link>
                        </td>
                        <td>
                          <router-link
                            :to="`/trip-request/vehicle-request/details/${request.id}/${requestRoute.id}`"
                            @click="
                              setSelectedRouteInfo(request.id, requestRoute.id)
                            "
                          >
                            {{
                              requestRoute.company_code
                                ? requestRoute.company_code
                                : 'N/A'
                            }}
                          </router-link>
                        </td>
                        <td>
                          <router-link
                            :to="`/trip-request/vehicle-request/details/${request.id}/${requestRoute.id}`"
                            @click="
                              setSelectedRouteInfo(request.id, requestRoute.id)
                            "
                          >
                            {{
                              requestRoute.duty_days
                                ? requestRoute.duty_days
                                : 'N/A'
                            }}
                          </router-link>
                        </td>
                        <td>
                          <router-link
                            :to="`/trip-request/vehicle-request/details/${request.id}/${requestRoute.id}`"
                            @click="
                              setSelectedRouteInfo(request.id, requestRoute.id)
                            "
                          >
                            {{
                              requestRoute.week_days
                                ? requestRoute.week_days
                                : 'N/A'
                            }}
                          </router-link>
                        </td>
                        <td>
                          <router-link
                            :to="`/trip-request/vehicle-request/details/${request.id}/${requestRoute.id}`"
                            @click="
                              setSelectedRouteInfo(request.id, requestRoute.id)
                            "
                          >
                            {{
                              $format.date(
                                requestRoute.duty_start_date,
                                'D/MM/YY'
                              )
                            }}
                          </router-link>
                        </td>
                        <td>
                          <router-link
                            :to="`/trip-request/vehicle-request/details/${request.id}/${requestRoute.id}`"
                            @click="
                              setSelectedRouteInfo(request.id, requestRoute.id)
                            "
                          >
                            {{
                              requestRoute.no_of_vehicle
                                ? requestRoute.no_of_vehicle
                                : 'N/A'
                            }}
                          </router-link>
                        </td>
                        <td>
                          <router-link
                            :to="`/trip-request/vehicle-request/details/${request.id}/${requestRoute.id}`"
                            @click="
                              setSelectedRouteInfo(request.id, requestRoute.id)
                            "
                          >
                            {{
                              requestRoute.vehicle_type
                                ? requestRoute.vehicle_type
                                : 'N/A'
                            }}
                          </router-link>
                        </td>
                        <td>
                          <router-link
                            :to="`/trip-request/vehicle-request/details/${request.id}/${requestRoute.id}`"
                            @click="
                              setSelectedRouteInfo(request.id, requestRoute.id)
                            "
                          >
                            {{
                              request.service_type?.name
                                ? request.service_type?.name
                                : 'N/A'
                            }}
                          </router-link>
                        </td>
                        <td>
                          <router-link
                            :to="`/trip-request/vehicle-request/details/${request.id}/${requestRoute.id}`"
                            @click="
                              setSelectedRouteInfo(request.id, requestRoute.id)
                            "
                          >
                            {{
                              requestRoute.modality
                                ? requestRoute.modality
                                : 'N/A'
                            }}
                          </router-link>
                        </td>
                        <td>
                          <router-link
                            :to="`/trip-request/vehicle-request/details/${request.id}/${requestRoute.id}`"
                            @click="
                              setSelectedRouteInfo(request.id, requestRoute.id)
                            "
                          >
                            {{
                              requestRoute.expected_price
                                ? requestRoute.expected_price
                                : 'N/A'
                            }}
                          </router-link>
                        </td>
                        <td>
                          <router-link
                            :to="`/trip-request/vehicle-request/details/${request.id}/${requestRoute.id}`"
                            @click="
                              setSelectedRouteInfo(request.id, requestRoute.id)
                            "
                          >
                            {{
                              userDetails[request.requested_by]
                                ? userDetails[request.requested_by].name
                                : 'N/A'
                            }}
                          </router-link>
                        </td>
                        <td>
                          <!-- <span
                        class="partner-hyperlink"
                        @click="selectRequest(request, index)"
                        data-bs-toggle="modal"
                        data-bs-target="#remarksOpsModal"
                        >See Details</span
                      > -->
                          <span
                            v-if="
                              request.ops_remark &&
                              request.ops_remark.length > 12
                            "
                            style="cursor: pointer"
                            @click="selectRequest(request, index)"
                            data-bs-toggle="modal"
                            data-bs-target="#remarksOpsModal"
                            >{{ request.ops_remark.substring(0, 12) }}...</span
                          >
                          <span v-else-if="request.ops_remark">
                            {{ request.ops_remark }}
                          </span>
                          <span v-else>N/A</span>
                        </td>
                        <td>
                          <router-link
                            :to="`/trip-request/vehicle-request/details/${request.id}/${requestRoute.id}`"
                            @click="
                              setSelectedRouteInfo(request.id, requestRoute.id)
                            "
                          ></router-link>
                          <span
                            v-if="requestRoute.request_status"
                            class="partner-badge partner-badge-pink rounded-pill"
                            >{{ requestRoute.request_status }}</span
                          ><span v-else>N/A</span>
                        </td>
                        <td>
                          <router-link
                            :to="`/trip-request/vehicle-request/details/${request.id}/${requestRoute.id}`"
                            @click="
                              setSelectedRouteInfo(request.id, requestRoute.id)
                            "
                          >
                            {{
                              userDetails[requestRoute.km_checked_by]
                                ? userDetails[requestRoute.km_checked_by].name
                                : 'N/A'
                            }}
                          </router-link>
                        </td>
                        <td>
                          <RequestAction
                            pageName="trip_list"
                            :requestRoute="requestRoute"
                            @selectRequest="selectRequest(request, index)"
                          ></RequestAction>
                        </td>
                        <td>
                          <router-link
                            v-if="
                              requestRoute.status === 'Accepted' &&
                              !requestRoute.fare_per_km &&
                              $userPermission.has('vehicle-request-set-price')
                            "
                            :to="{
                              name: 'vehicle-request-details-id',
                              params: {
                                trip_request_id: request.id,
                                route_id: requestRoute.id
                              },
                              hash: '#setTRPrice'
                            }"
                            hash
                            class="btn btn-sm btn-primary no-text-break"
                          >
                            Set TR Price
                          </router-link>
                          <!-- <router-link
                        v-if="
                          requestRoute.fare_per_km &&
                          !requestRoute.assigned_driver_details
                        "
                        class="btn btn-sm btn-primary no-text-break"
                        :to="{
                          name: 'vehicle-request-details-id',
                          params: {
                            trip_request_id: request.id,
                            route_id: requestRoute.id
                          },
                          hash: '#assignDriver'
                        }"
                      >
                        Assign Driver
                      </router-link> -->
                          <button
                            v-if="
                              requestRoute.fare_per_km &&
                              !requestRoute.assigned_driver_details &&
                              $userPermission.has(
                                'vehicle-request-driver-assign'
                              )
                            "
                            class="btn btn-sm btn-primary no-text-break"
                            data-bs-toggle="modal"
                            data-bs-target="#assignDriverModal"
                            @click="selectRequest(request, index)"
                          >
                            Assign Driver
                          </button>
                        </td>
                        <td>
                          <router-link
                            :to="`/trip-request/vehicle-request/details/${request.id}/${requestRoute.id}`"
                            @click="
                              setSelectedRouteInfo(request.id, requestRoute.id)
                            "
                          >
                            {{
                              requestRoute.assigned_driver_details &&
                              requestRoute.assigned_driver_details.partner_id &&
                              userDetails[
                                requestRoute.assigned_driver_details.partner_id
                              ]
                                ? userDetails[
                                    requestRoute.assigned_driver_details
                                      .partner_id
                                  ].name
                                : 'N/A'
                            }}
                          </router-link>
                        </td>
                        <td>
                          <span
                            class="partner-hyperlink"
                            data-bs-toggle="modal"
                            data-bs-target="#remarksPartnersModal"
                            @click="selectRequest(request, index)"
                            >See Details</span
                          >
                        </td>
                      </tr>
                    </template>
                  </template>
                </tbody>
              </table>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="vr-pagination">
                <p>
                  Showing {{ this.dataInfo.from }}-{{ this.dataInfo.to }} out of
                  {{ this.dataInfo.total }}
                </p>
                <paginate
                  class="paginate"
                  :totalPages="dataInfo.totalPages"
                  :total="dataInfo.total"
                  :currentPage="dataInfo.currentPage"
                  :perPage="dataInfo.perPage"
                  v-on:pagechanged="changePage"
                ></paginate>
              </div>
            </div>
          </div>
        </template>
        <NoDataMessage v-else></NoDataMessage>
      </div>
    </div>
  </div>

  <!-- Proposal from B2B Modal -->
  <teleport to="body">
    <div
      class="modal fade partner-modal"
      id="proposalModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-sm">
        <Proposal
          :request="selectedRequest"
          @refreshData="getTripRequests()"
        ></Proposal>
      </div>
    </div>
  </teleport>

  <!-- Remarks (Ops) Modal -->
  <teleport to="body">
    <div
      class="modal fade partner-modal"
      id="remarksOpsModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <RemarksOps :request="selectedRequest"></RemarksOps>
      </div>
    </div>
  </teleport>

  <!-- Remarks (Partners) Modal -->
  <teleport to="body">
    <div
      class="modal fade partner-modal"
      id="remarksPartnersModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <RemarksPartners
          :request="selectedRequest"
          @refreshData="getTripRequests()"
        ></RemarksPartners>
      </div>
    </div>
  </teleport>

  <!-- Cancel Proposal Modal -->
  <teleport to="body">
    <div
      class="modal fade partner-modal"
      id="cancelProposalModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-sm">
        <CancelProposal
          :request="selectedRequest"
          @refreshData="getTripRequests()"
        ></CancelProposal>
      </div>
    </div>
  </teleport>

  <!-- Assign Driver Modal -->
  <teleport to="body">
    <div
      class="modal fade partner-modal"
      id="assignDriverModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
    >
      <div class="modal-dialog modal-lg">
        <AssignDriver
          :requestDetails="selectedRequestDetails"
          :selectedRouteIndex="selectedRouteIndex"
          :bonusObj="bonusObj"
          @refreshData="getTripRequests()"
        ></AssignDriver>
      </div>
    </div>
  </teleport>

  <!-- Map Modal -->
  <teleport to="body">
    <div
      class="modal fade partner-modal"
      id="mapModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Map</h5>
            <button
              ref="modalCloseBtn"
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <i class="bi bi-x-circle"></i>
            </button>
          </div>
          <div class="modal-body">
            <DirectionMap :mapData="selectedRequest?.route_map"></DirectionMap>
          </div>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
import http from '../../config/axios';
import Paginate from '../pagination/PartnerPagination.vue';
// import Loader from '../../components/lib/Loader';
import TripRequestPageHeading from './TripRequestPageHeading.vue';
import RemarksOps from './vehicleRequest/RemarksOps.vue';
import RemarksPartners from './vehicleRequest/RemarksPartners.vue';
import Proposal from './vehicleRequest/Proposal.vue';
import CancelProposal from './vehicleRequest/CancelProposal.vue';
import userServiceAPI from '@/store/userServiceAPI';
import { vehicleRequest } from '../../store/vehicleRequest/vehicleRequest';
import AssignDriver from './vehicleRequest/AssignDriver.vue';
import DirectionMap from './map/DirectionMap.vue';
import RequestAction from './vehicleRequest/RequestAction.vue';

export default {
  name: 'VehicleRequestList',
  props: ['swal'],
  components: {
    Paginate,
    // Loader,
    TripRequestPageHeading,
    RemarksOps,
    RemarksPartners,
    Proposal,
    CancelProposal,
    AssignDriver,
    DirectionMap,
    RequestAction
  },
  data() {
    return {
      permission: null,
      isLoading: false,
      requestList: [],
      selectedRequestDetails: {},
      selectedRouteIndex: 0,
      selectedRequest: {},
      userDetails: {},
      dataInfo: {
        total: 0,
        totalPages: 0,
        currentPage: this.$route.params.page_number
          ? this.$route.params.page_number
          : 1,
        perPage: this.$route.params.per_page ? this.$route.params.per_page : 50,
        to: 0,
        from: 0
      },
      filterValues: {
        routeName: '',
        requestedDate: '',
        distance: '',
        time: '',
        companyCode: '',
        dutyDays: '',
        dutyStartDate: '',
        serviceType: '',
        vehicleType: '',
        modality: '',
        requestedBy: '',
        status: '',
        assignedDriver: '',
        trId:''
      },
      filterString: this.$route.params.filter_data
        ? this.$route.params.filter_data
        : '',
      bonusIds: {},
      bonusObj: {},
      bonusTypes: [],
      downloadingTripList: false,
      selectedRouteInfo: {},
      vehicleRequest
    };
  },
  mounted() {
    this.permission = localStorage.getItem('userPermission').split(',');
    this.getBonusTypes();
    if (!this.filterString) {
      this.getTripRequests();
    }
  },
  beforeUnmount() {
    this.saveLastScrollPosition();
  },
  watch: {
    'dataInfo.perPage': function () {
      this.dataInfo.currentPage = 1;
      this.updateRoute();
      this.getTripRequests();
    },
    'dataInfo.currentPage': function () {
      this.updateRoute();
    },
    '$route.params': {
      handler: function () {
        if (this.$route.name === 'vehicle-request') {
          if (
            !this.$route.params.per_page ||
            !this.$route.params.page_number ||
            !this.$route.params.filter_data
          ) {
            this.updateRoute();
          }
        }
      },
      deep: true
    }
  },
  methods: {
    getUserCodesFromRequestList(data) {
      let userCodes = new Set();
      data.forEach((ele) => {
        if (ele.requested_by) {
          userCodes.add(ele.requested_by);
        }
        ele.trip_request_routes.forEach((route) => {
          if (route.km_checked_by) {
            userCodes.add(route.km_checked_by);
          }
          if (
            route.assigned_driver_details &&
            route.assigned_driver_details.partner_id
          ) {
            userCodes.add(route.assigned_driver_details.partner_id);
          }
        });
      });
      return [...userCodes];
    },
    setUserDetails(data) {
      data.forEach((ele) => {
        this.userDetails[ele.user_code] = ele;
      });
    },
    changePage(page_number) {
      this.dataInfo.currentPage = page_number;
      this.getTripRequests();
    },
    getTripRequests() {
      this.isLoading = true;
      http
        .get(
          `v2/partners/triprequests?pagination_value=${this.dataInfo.perPage}&page=${this.dataInfo.currentPage}&routeName=${this.filterValues.routeName}&requestedDate=${this.filterValues.requestedDate}&distance=${this.filterValues.distance}&time=${this.filterValues.time}&companyCode=${this.filterValues.companyCode}&dutyDays=${this.filterValues.dutyDays}&dutyStartDate=${this.filterValues.dutyStartDate}&serviceType=${this.filterValues.serviceType}&vehicleType=${this.filterValues.vehicleType}&modality=${this.filterValues.modality}&requestedBy=${this.filterValues.requestedBy}&status=${this.filterValues.status}&tr_id=${this.filterValues.trId}`
          // &assignedDriver=${this.filterValues.assignedDriver}
        )
        .then((response) => {
          this.requestList = response.data.data.data;
          this.dataInfo.total = response.data.data.total;
          this.dataInfo.totalPages = response.data.data.last_page;
          this.dataInfo.currentPage = response.data.data.current_page;
          // this.dataInfo.perPage = response.data.data.per_page;
          this.dataInfo.to = response.data.data.to;
          this.dataInfo.from = response.data.data.from;

          let allUserCodes = this.getUserCodesFromRequestList(this.requestList);
          // Fetch users from user service
          userServiceAPI
            .getUserDetails(allUserCodes)
            .then((res) => {
              this.isLoading = false;
              this.restoreSavedScrollPosition();
              this.setUserDetails(res.data.data);
            })
            .catch(() => {
              this.isLoading = false;
            });
        })
        .catch((error) => {
          this.isLoading = false;
          this.$partnerSwal.errorToast.fire({
            title: 'Error!',
            text: error.response.data?.message
          });
        });
    },
    downloadTripList(page_number) {
      this.downloadingTripList = true;
      let url = `v2/partners/triprequests?pagination_value=${this.dataInfo.perPage}&page=${page_number}&routeName=${this.filterValues.routeName}&requestedDate=${this.filterValues.requestedDate}&distance=${this.filterValues.distance}&time=${this.filterValues.time}&companyCode=${this.filterValues.companyCode}&dutyDays=${this.filterValues.dutyDays}&dutyStartDate=${this.filterValues.dutyStartDate}&serviceType=${this.filterValues.serviceType}&vehicleType=${this.filterValues.vehicleType}&modality=${this.filterValues.modality}&requestedBy=${this.filterValues.requestedBy}&status=${this.filterValues.status}&download_trip_details=1`;

      http
        .get(url, { responseType: 'arraybuffer' })
        .then((response) => {
          this.downloadingTripList = false;
          const url = URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `trip_list.xlsx`);
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          this.downloadingTripList = false;
          this.$partnerSwal.errorToast.fire({
            title: 'Error!',
            text: error.response.data?.message
          });
        });
    },
    updateRoute() {
      this.$router.push({
        name: 'vehicle-request',
        params: {
          per_page: this.dataInfo.perPage,
          page_number: this.dataInfo.currentPage,
          filter_data: this.filterString
        }
      });
    },
    putFilterDataOnRoute(selectedFilters) {
      this.filterString = '';
      if (selectedFilters?.length > 0) {
        selectedFilters.forEach((element) => {
          if (this.filterValues[element]) {
            this.filterString +=
              '&' +
              encodeURIComponent(element) +
              '=' +
              encodeURIComponent(this.filterValues[element]);
          }
        });
      }
      this.updateRoute();
    },
    filterData(filterValues = null, selectedFilters = [], page_no) {
      this.filterValues = filterValues;
      this.dataInfo.currentPage = page_no;
      this.getTripRequests();
      this.putFilterDataOnRoute(selectedFilters);
    },
    selectRequest(request, index) {
      this.selectedRequest = request.trip_request_routes[index];
      this.selectedRequest.service_type = request.service_type;
      this.selectedRequest.ops_remark = request.ops_remark;

      // For Assign Driver modal
      this.selectedRequestDetails = request;
      this.selectedRouteIndex = index;
    },
    mapBonus() {
      this.bonusTypes.forEach((element) => {
        this.bonusIds[element.bonus_name] = element.id;
        this.bonusObj[element.id] = element;
      });
    },
    getBonusTypes() {
      this.isBonusLoading = true;
      http
        .get('v2/partners/bonus')
        .then((response) => {
          this.bonusTypes = response.data.data;
          this.mapBonus();
        })
        .catch((error) => {
          this.$partnerSwal.errorToast.fire({
            title: 'Error Loading Bonus Types!',
            text: error.response.data?.message
          });
        });
    },
    setSelectedRouteInfo(trip_request_id, route_id) {
      this.selectedRouteInfo = {
        trip_request_id: trip_request_id,
        route_id: route_id
      };
    },
    saveLastScrollPosition() {
      if (this.$refs.trTableHolder) {
        let scrollPosition = {
          top: this.$refs.trTableHolder.scrollTop,
          left: this.$refs.trTableHolder.scrollLeft,
          selectedRouteInfo: this.selectedRouteInfo
        };
        localStorage.setItem(
          'trPageScrolledPosition',
          JSON.stringify(scrollPosition)
        );
      }
    },
    restoreSavedScrollPosition() {
      let forwardUrl = this.$router.options.history.state.forward;
      let savedScrollPosition = localStorage.getItem('trPageScrolledPosition');

      if (savedScrollPosition) {
        savedScrollPosition = JSON.parse(savedScrollPosition);
      } else {
        this.selectedRouteInfo = {};
      }
      if (savedScrollPosition && forwardUrl) {
        localStorage.removeItem('trPageScrolledPosition');
        setTimeout(() => {
          if (this.$refs.trTableHolder) {
            this.$refs.trTableHolder.scrollTop = savedScrollPosition.top;
            this.$refs.trTableHolder.scrollLeft = savedScrollPosition.left;
            this.selectedRouteInfo = savedScrollPosition.selectedRouteInfo;
          }
        }, 5);
      }
    }
  }
};
</script>

<style scoped>
.table {
  font-size: 13px;
  font-weight: 400;
}

.table thead > tr > th {
  vertical-align: bottom;
  border-bottom: 2px solid #f8f9fa;
  background: #f3f3f3;
}

.table tbody > tr > td {
  vertical-align: middle;
}

#searchButton {
  background: #1c2457;
}

#searchButton:hover,
#searchButton:focus,
#searchButton:active {
  background: #1c2457;
}

.vr-pagination {
  display: flex;
  justify-content: right;
  align-items: center;
  margin-top: 13px;
}
.vr-pagination p {
  font-weight: 500;
  font-size: 14px;
  line-height: 14px;
  margin-bottom: 0;
}

.focused-row td {
  background: #ececec !important;
}

@media (min-width: 992px) and (max-width: 1199.98px) {
  .dataTables_filter,
  .dataTables_info {
    display: none;
  }

  .filter-style {
    text-align: center;
  }

  .dropdown {
    text-align: end;
  }
}
</style>
